import React from 'react';
import { Link } from 'react-router-dom';
import AppFooter from './AppFooter';
import './PolicyPage.css';

const RefundPolicy: React.FC = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <img src="/white_wide_logo_noBG.png" alt="GallopAI" className="policy-logo" />
        <h1 className="policy-title">Refund Policy</h1>
        <p className="policy-updated">Last Updated: 19 November, 2025</p>
      </div>
      
      <div className="policy-content">
        <div className="policy-card">
          <div className="policy-section">
            <h2 className="policy-section-title">14-Day Money Back Guarantee</h2>
            <p className="policy-text">
              If for any reason you are unhappy with the service, you can have a full refund within 14 days of signing up. Contact us and your refund will be processed within 1 day.
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Trial Period</h2>
            <p className="policy-text">
              Free trial - You can cancel at any time during the trial period with nothing else to pay. This must be done DURING the trial & not afterwards. Contact us and your cancellation will be processed within 1 day.
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Fair Use Policy</h2>
            <p className="policy-text">
              New GallopAI customers only are entitled to ONE refund or trial.
            </p>
            <p className="policy-text">
              If you've had a subscription to GallopAI previously that lapsed then you won't be entitled to a refund if you rejoin.
            </p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-title">Need to Request a Refund?</h2>
            <p className="policy-text">
              Please contact our support team and we'll process your request within 1 business day.
            </p>
            <Link to="/contact" target="_blank" rel="noopener noreferrer" className="policy-button">
              Contact Support
            </Link>
          </div>
        </div>
      </div>

      <AppFooter />
    </div>
  );
};

export default RefundPolicy;

